export default __webpack_public_path__ + "static/media/wisdom-pic1.0c403717.png";